<template>
  <div
    class="back"
    @click="itemClick()"
    :style="{
      backgroundColor: isSelected ? '#4972f0' : 'unset',
    }"
  >
    <span
      :class="this.className"
      :style="{ color: isSelected ? '#ffffff' : '#64696f' }"
    >
    </span>
    <p
      class="itemTitle"
      :style="{
        color: isSelected ? '#ffffff' : '#64696f',
      }"
    >
      {{ info.tagName }}
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      className: "",
    };
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  created() {},
  mounted() {
    this.className = `iconfont ${this.info.tagImg} icon`;
  },
  methods: {
    itemClick() {
      this.$emit("itemClick", this.info);
    },
  },
};
</script>
<style lang="scss" scoped>
.back {
  border-radius: 0px 20px 20px 0px;
  border-style: none;
  width: 184px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin: 6px 0px;
  overflow: hidden;
}
.icon {
  margin-left: 36px;
  width: 14px;
  height: 14px;
  margin-right: 20px;
}
.itemTitle {
  font-size: 14px;
  line-height: 20px;
  margin: 0px;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .back {
    border-radius: 0px 20px 20px 0px;
    border-style: none;
    width: 184px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    margin: 6px 0px;
    overflow: hidden;
  }
  .icon {
    margin-left: 36px;
    width: 14px;
    height: 14px;
    margin-right: 20px;
    font-size: 14px;
  }
  .itemTitle {
    font-size: 14px;
    line-height: 20px;
    margin: 0px;
    text-align: center;
  }
}
</style>
